import {Alert} from "react-bootstrap";
import {docs} from "../../i18n";

// Why the documentation's PDFs need a session, and are marked with who downloaded them.
export function DocumentationNotice() {
    return (
        <Alert variant="secondary" className="d-flex gap-2 align-items-start">
            <i className="bi bi-file-earmark-pdf" aria-hidden="true"></i>
            <div>{docs.page.pdfNotice}</div>
        </Alert>
    );
}
